import React, { useEffect, useState } from "react";
import { API_URL } from "../utils/Function";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import "../Css/ProductDetailspage.css"; // ← reuse same UI styles

const PlanTable = () => {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(0);
  const [selectedPlan, setSelectedPlan] = useState("basic");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(
          `${API_URL}/product.php/get?limit=2&is_active=1`
        );

        const data = await response.json();
        console.log("API:", data);

        if (Array.isArray(data.products)) {
          setProducts(data.products);
        }
      } catch (err) {
        console.error("Error:", err);
      }
    };

    fetchProducts();
  }, []);

  if (products.length === 0) {
    return <p>Loading products...</p>;
  }

  const product = products[selectedProduct];

  // Determine existing plans
  const hasBasicPlan = product.plan_basic_desc?.trim();
  const hasStandardPlan = product.plan_standard_desc?.trim();
  const hasPremiumPlan = product.plan_premium_desc?.trim();

  if (!hasBasicPlan && !hasStandardPlan && !hasPremiumPlan) {
  return null;  
}

  const planTabs = [];
  if (hasBasicPlan) planTabs.push("basic");
  if (hasStandardPlan) planTabs.push("standard");
  if (hasPremiumPlan) planTabs.push("premium");

  const planLabels = {
    basic: "Basic",
    standard: "Standard",
    premium: "Premium",
  };

const renderIcon = (value) => {
  if (!value || value === "✗") {
    return (
      <div className="icon-center">
        <div className="icon-wrapper cross">
          <FontAwesomeIcon icon={faTimes} />
        </div>
      </div>
    );
  }

  if (value === "✓") {
    return (
      <div className="icon-center">
        <div className="icon-wrapper check">
          <FontAwesomeIcon icon={faCheck} />
        </div>
      </div>
    );
  }

  // text values → left aligned
  return <span className="text-left-value">{value}</span>;
};

  return (
    <div className="container py-4">
        <h1 className="mb-5 fw-bold text-center">Our <span style={{borderBottom:"4px solid #9374FF"}}>Products Plan</span> </h1>

      {/* PRODUCT TABS */}
<ul className="nav nav-tabs fullwidth-tabs">
  {products.map((p, index) => (
    <li className="nav-item flex-fill text-center" key={index}>
      <button
        className={`nav-link w-100 ${selectedProduct === index ? "active" : ""}`}
        onClick={() => {
          setSelectedProduct(index);
          setSelectedPlan("basic");
        }}
      >
        {(p.name).toUpperCase()}
      </button>
    </li>
  ))}
</ul>


      <h2 className="text-center mt-4 fw-bold">{(product.name).toUpperCase()} — Choose Your Plan</h2>

      {/* PLAN DESCRIPTION CARDS */}
      <div className="row g-4 mb-4 mt-2">

        {hasBasicPlan && (
          <div className="col-lg-4">
            <div className="plan-description-card">
              <h4 className="plan-desc-title">Basic Plan</h4>
              <p className="plan-desc-text">{product.plan_basic_desc}</p>
            </div>
          </div>
        )}

        {hasStandardPlan && (
          <div className="col-lg-4">
            <div className="plan-description-card plan-desc-featured">
              <h4 className="plan-desc-title">Standard Plan</h4>
              <p className="plan-desc-text">{product.plan_standard_desc}</p>
            </div>
          </div>
        )}

        {hasPremiumPlan && (
          <div className="col-lg-4">
            <div className="plan-description-card">
              <h4 className="plan-desc-title">Premium Plan</h4>
              <p className="plan-desc-text">{product.plan_premium_desc}</p>
            </div>
          </div>
        )}

      </div>

      {/* PLAN COMPARISON TABLE */}
      {product.plan_overview_array?.length > 0 && (
        <div className="plan-comparison-table-wrapper">
          <table className="plan-comparison-table table table-bordered">

            <thead>
              <tr>
                <th className="overview-heading-col">Overview</th>
                {hasBasicPlan && <th className="plan-col plan-basic">Basic</th>}
                {hasStandardPlan && <th className="plan-col plan-standard">Standard</th>}
                {hasPremiumPlan && <th className="plan-col plan-premium">Premium</th>}
              </tr>
            </thead>

            <tbody>
              {product.plan_overview_array.map((item, idx) => (
                <tr key={idx}>
                  <td className="overview-heading-cell">{item.heading}</td>

                  {hasBasicPlan && (
                    <td className="plan-feature-cell">{renderIcon(item.basic)}</td>
                  )}

                  {hasStandardPlan && (
                    <td className="plan-feature-cell">{renderIcon(item.standard)}</td>
                  )}

                  {hasPremiumPlan && (
                    <td className="plan-feature-cell">{renderIcon(item.premium)}</td>
                  )}
                </tr>
              ))}
            </tbody>

            {/* CONTACT US SECTION */}
            <tfoot>
              <tr>
                <td></td>

                {hasBasicPlan && (
                  <td>
                    <button
                      className="plan-action-btn btn-basic"
                      onClick={() =>
                        navigate("/contactus", {
                          state: {
                            planInfo: {
                              productName: product.name,
                              planName: "Basic",
                              planType: "basic",
                            },
                          },
                        })
                      }
                    >
                      Contact Us
                    </button>
                  </td>
                )}

                {hasStandardPlan && (
                  <td>
                    <button
                      className="plan-action-btn btn-standard"
                      onClick={() =>
                        navigate("/contactus", {
                          state: {
                            planInfo: {
                              productName: product.name,
                              planName: "Standard",
                              planType: "standard",
                            },
                          },
                        })
                      }
                    >
                      Contact Us
                    </button>
                  </td>
                )}

                {hasPremiumPlan && (
                  <td>
                    <button
                      className="plan-action-btn btn-premium"
                      onClick={() =>
                        navigate("/contactus", {
                          state: {
                            planInfo: {
                              productName: product.name,
                              planName: "Premium",
                              planType: "premium",
                            },
                          },
                        })
                      }
                    >
                      Contact Us
                    </button>
                  </td>
                )}
              </tr>
            </tfoot>

          </table>
        </div>
      )}

    </div>
  );
};

export default PlanTable;
